<template>
	<ChatHeader :isDM="true">
		<div class="chat-header-details">
			<div v-if="creator" class="chat-header-title">
				<Mention :key="creator.id" :user="creator" :isMe="isMe(creator.id)" />
				{{
					!selfDM
						? $t('chat_stream_header_description_dm_with_creator', {
								CreatedDate: createdAt,
						  })
						: $t('chat_stream_header_description_dm_self', {
								CreatedDate: createdAt,
						  })
				}}

				<span v-for="(member, index) in members" :key="member.id">
					<Mention
						:key="member.id"
						:user="member"
						:isMe="isMe(member.id)"
					/><template v-if="index !== members.length - 1">, </template>
				</span>
			</div>
			<div class="chat-header-title" v-else>
				{{
					$t('chat_stream_header_description_dm_no_creator', {
						CreatedDate: createdAt,
					})
				}}
				<span v-for="(member, index) in members" :key="member.id">
					<Mention
						:key="member.id"
						:user="member"
						:isMe="isMe(member.id)"
					/><template v-if="index !== members.length - 1">, </template>
				</span>
			</div>
		</div>
	</ChatHeader>
</template>

<script setup>
import { computed } from 'vue'
import {
	getCurrentChat,
	getChat,
	getUser,
	getMembershipsForBubble,
	getMyUserId,
} from '@/store'
import ChatHeader from './ChatHeader.vue'
import moment from 'moment'
import { useI18n } from 'vue-i18n'
import Mention from '@/components/Message/Mention'

const props = defineProps({
	chatId: { type: Number, default: null },
})

const { t } = useI18n()

//computed properties
const chat = computed(() => {
	if (props.chatId) {
		return getChat(props.chatId) || {}
	}
	return getCurrentChat()
})

const createdAt = computed(() => {
	return moment(chat.value.created_at).local().format('M/D/YY')
})

const creator = computed(() => {
	return getUser(chat.value.user_id)
})

// TODO: Add functionality to show multiple dm partners
const dmPartner = computed(() => {
	return getUser(chat.value.dmpartner_id)
})

const selfDM = computed(() => {
	return !dmPartner.value && members.value.length === 0
})

const members = computed(() => {
	const memberships = getMembershipsForBubble(chat.value.id)
	const creatorId = chat.value.user_id
	const myId = getMyUserId()

	// If I'm the creator, filter myself out
	// If I'm not the creator, filter out the creator
	const filteredMemberships = memberships.filter((m) =>
		myId === creatorId ? m.user_id !== myId : m.user_id !== creatorId
	)

	return filteredMemberships
		.map((m) => getUser(m.user_id))
		.sort((a, b) => a.firstname.localeCompare(b.firstname))
})

function isMe(user_id) {
	return user_id === getMyUserId()
}
</script>

<style lang="scss" scoped>
.chat-header-details {
	color: var(--neutral-800);
	font-family: Avenir-Medium;
	font-size: 17px;
	font-weight: 400;
	margin-top: 10px;
	margin-bottom: 5px;
	.chat-header-title {
		font-family: Avenir-Book;
	}
}
</style>
